import { createApiClient, RequestResponse } from 'src/lib/api-client'
import useSWR, { SWRConfiguration } from 'swr'

import { explanationCacheKey } from '../cacheKey'

type ExpReservationTypeRes = Extract<
  RequestResponse<
    '/trials/{trial_uid}/explanation_reservations/{explanation_reservation_uid}/reservation_scene',
    'get'
  >,
  { result: 'success' }
>['data']

const expReservationScene = async ({
  trialUid,
  explanationReservationUid,
}: {
  trialUid: string
  explanationReservationUid: string
}): Promise<ExpReservationTypeRes> => {
  const res = await createApiClient({
    path: '/trials/{trial_uid}/explanation_reservations/{explanation_reservation_uid}/reservation_scene',
    httpMethod: 'get',
    params: {
      paths: {
        trial_uid: trialUid,
        explanation_reservation_uid: explanationReservationUid,
      },
    },
  }).request()

  if (res.result === 'error') {
    throw new Error(res.error.data.message)
  }

  return res.data
}

export const useExpReservationScene = ({
  shouldCancel,
  trialUid,
  explanationReservationUid,
  ...option
}: {
  shouldCancel?: boolean
  trialUid: string
  explanationReservationUid: string
} & SWRConfiguration<ExpReservationTypeRes, Error>) => {
  return useSWR(
    shouldCancel
      ? null
      : explanationCacheKey.expReservationScene(explanationReservationUid),
    () =>
      expReservationScene({
        trialUid,
        explanationReservationUid,
      }),
    option,
  )
}
